import React from 'react';

const Traduccion = ({ data }) => {
    const imageUrl = data.image ? `${process.env.REACT_APP_BACKEND_URL}/api/cuentos/ilustraciones/${data.image}` : null;

    return (
        <div className="mb-8 pb-6 border-b border-sage-200/60 mt-6">
            {/* Título centrado con el mismo estilo que el título original */}
            <div className="font-bold text-4xl lg:text-5xl text-center mb-8 text-primary-800 font-japanese">
                {data.title}
            </div>

            {/* Imagen de portada */}
            {imageUrl && (
                <div className="p-4 w-full md:w-2/3 lg:w-1/2 mx-auto mb-8">
                    <div className="rounded-lg border-2 border-gray-300 shadow-lg p-4 bg-white">
                        <img 
                            src={imageUrl} 
                            alt="Portada del cuento" 
                            className="rounded w-full object-cover" 
                        />
                    </div>
                </div>
            )}

            {/* Párrafos de la traducción */}
            <div className="max-w-4xl mx-auto px-4">
                {data.paragraphs.map((paragraph, index) => (
                    <p 
                        key={index}
                        className="text-lg lg:text-xl text-gray-800 mb-6 leading-relaxed text-justify indent-8"
                    >
                        {paragraph}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default Traduccion;
